<div class="body">
  @if (currentSlide === 'LOGIN') {
    <form id="login" @rotorLogin [formGroup]="form" (ngSubmit)="submit()">
      <h1>
        <img src="assets/images/common/tripium.logo.svg" alt="Logo" class="login-tripium-logo" />
      </h1>
      <fieldset id="inputs">
        <input
          id="username"
          type="text"
          placeholder="Username"
          formControlName="username"
          autofocus
          required
        />
        <!--      <input id="password" type="password" placeholder="Password" formControlName="password" required>-->
        <input
          id="password"
          [type]="(showPwd) ? 'text' : 'password'"
          placeholder="Password"
          formControlName="password"
          required
        />
        <a class="show-hide-pwd" (click)="showHidePwd()">
          @if (!showPwd) {
            <i nz-icon nzType="eye-invisible" nzTheme="outline"></i>
          } @else {
            <i nz-icon nzType="eye" nzTheme="outline"></i>
          }
        </a>
      </fieldset>
      <fieldset id="actions">
        <input type="submit" id="submit" value="Log in" [disabled]="form.invalid || submitted" />
        <a (click)="goToSlide('FORGOT');">Forgot your password?</a>
      </fieldset>
    </form>
  }

  @if (currentSlide === 'FORGOT') {
    <form id="forgot" @rotorForgot [formGroup]="formForgot" (ngSubmit)="forgot()">
      <h1>
        <img src="assets/images/common/tripium.logo.svg" alt="Logo" class="login-tripium-logo" />
      </h1>
      <fieldset id="inputsForgot">
        <input
          id="usernameForgot"
          type="text"
          placeholder="Username"
          formControlName="usernameForgot"
          autofocus
          required
        />
      </fieldset>
      <fieldset id="actionsForgot">
        <input
          type="submit"
          id="submitForgot"
          value="Restore"
          [disabled]="formForgot.invalid || submitted"
        />
        <a (click)="goToSlide('LOGIN');">Go Back To Login</a>
      </fieldset>
    </form>
  }

  @if (currentSlide === 'RESET') {
    <form id="reset" @rotorForgot [formGroup]="formReset" (ngSubmit)="resetPwd()">
      <h1>
        <img src="assets/images/common/tripium.logo.svg" alt="Logo" class="login-tripium-logo" />
      </h1>
      @if (oneTimePassword) {
        <p class="reset-hint">Please set a new password. It cannot be the same as the password provided by the administrator.</p>
      }
      <fieldset id="inputsReset">
        <input
          id="passwordReset1"
          type="password"
          placeholder="Password"
          formControlName="passwordReset1"
          required
        />
        @if (resetPasswordError('passwordReset1', 'minlength')) {
          <p class="field-error">Password must be at least {{ passwordMinLength }} characters.</p>
        }
        @if (resetPasswordError('passwordReset1', 'sameAsOneTime')) {
          <p class="field-error">New password must be different from the password provided by the administrator.</p>
        }
        <input
          id="passwordReset2"
          type="password"
          placeholder="Confirm Password"
          formControlName="passwordReset2"
          required
        />
        @if (resetPasswordsMismatch()) {
          <p class="field-error">Passwords are not equal.</p>
        }
      </fieldset>
      <fieldset id="actionsReset">
        <input
          type="submit"
          id="submitReset"
          value="Reset"
          [disabled]="formReset.invalid || submitted"
        />
        <a (click)="goToSlide('LOGIN');">Go Back To Login</a>
      </fieldset>
    </form>
  }

  <div class="version">Ver: {{ environment['version'] }} Rev: {{ environment['revision'] }}</div>
</div>
